export default __webpack_public_path__ + "static/media/gallery_03.4f6a1664.jpg";